import React, { Component } from 'react';
import ReactLoading from 'react-loading';
import { Button, FormControlLabel } from '@mui/material';
import Constants from '../../../../constants/Constants';
import DateTimeRangeInput from '../InputControls/DateTimeRangeInput';
import DateTimeRangeRounding from '../InputControls/DateTimeRangeRounding';
import StringInput from '../InputControls/StringInput';
import DropdownInput from '../InputControls/DropdownInput';
import RadioInput from '../InputControls/RadioInput';
import ButtonInput from '../InputControls/ButtonInput';

const FilterItem = (props) => (
  <div className="u-fx u-fx-align-center u-mb-full">
    <FilterItemSwitcher settings={props.settings} query={props.query} onChanged={props.onChanged} />
  </div>
);

const FilterItemSwitcher = (props) => {
  switch (props.settings.type) {
    case 'TimeRange':
      return (
        <DateTimeRangeInput
          settings={props.settings}
          query={props.query}
          onChanged={props.onChanged}
        />
      );
    case 'TimeRangeRounding':
      return (
        <DateTimeRangeRounding
          settings={props.settings}
          query={props.query}
          onChanged={props.onChanged}
        />
      );
    case 'Dropdown':
      return (
        <DropdownInput settings={props.settings} query={props.query} onChanged={props.onChanged} />
      );
    case 'Radio':
      return (
        <RadioInput settings={props.settings} query={props.query} onChanged={props.onChanged} />
      );
    case 'String':
      return null;
    //<StringInput settings={props.settings} />;
    case 'Button':
      return (
        <ButtonInput settings={props.settings} query={props.query} onChanged={props.onChanged} />
      );
    default:
      return null;
  }
};

class Filter extends Component {
  constructor(props) {
    super(props);

    this.onChanged = this.onChanged.bind(this);
    this.onApplyFilters = this.onApplyFilters.bind(this);
  }

  onChanged = (newValues, sender) => {
    let changes = { ...newValues };
    if (sender && sender.mode && sender.mode.confirm === 'auto') {
      changes.$reload = true;
    }
    this.props.onQueryChanged(changes, `filter-${sender ? sender.name : 'self'}`);
  };

  onApplyFilters = () => {
    this.onChanged({ $reload: true }, 'filter-apply');
  };

  render() {
    return (
      <>
        {this.props.configuration.fields.map((field, index) => (
          <FilterItem
            settings={field}
            query={this.props.query}
            onChanged={this.onChanged}
            key={index}
          />
        ))}
        {this.props.configuration.showApply ? (
          <div className="u-mt-double u-mb-half u-fx u-fx-align-center">
            <Button
              variant="contained"
              onClick={this.onApplyFilters}
              color="primary"
              disabled={this.props.isFetching}
              data-qa="qa-apply-filters"
            >
              Apply
            </Button>
            {this.props.isFetching ? (
              <ReactLoading
                className="u-ml-double"
                type="bubbles"
                color="#34495e"
                height={'36px'}
                width={'36px'}
              />
            ) : null}
            {!this.props.isFetching &&
            this.props.configuration.metadata &&
            !this.props.configuration.metadata.HasData ? (
              <p className="u-ml-double u-italic" style={{ color: Constants.COLORS.WARNING }}>
                {Constants.ZERO_RESULTS}
              </p>
            ) : null}
            {!this.props.isFetching &&
            this.props.configuration.metadata &&
            this.props.configuration.metadata.HasMoreData ? (
              <p className="u-ml-double u-italic" style={{ color: Constants.COLORS.WARNING }}>
                {Constants.MORE_THAN_CONFIGURED_RESULTS}
              </p>
            ) : null}
          </div>
        ) : null}
      </>
    );
  }
}

export default Filter;
